import { render, staticRenderFns } from "./XomeInstructionsConfirm.vue?vue&type=template&id=320754a4&"
import script from "./XomeInstructionsConfirm.vue?vue&type=script&lang=js&"
export * from "./XomeInstructionsConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports